import { useRef, useLayoutEffect, useCallback } from "react";

/**
 * Persists a function between renders.
 */
export function useCallbackRef(callback) {
  const ref = useRef(callback);
  useLayoutEffect(() => {
    ref.current = callback;
  });
  const fn = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current?.(...args);
  };
  return useCallback(fn, []);
}